/** Practice-topic hub rows: Start / Resume / Retake from DB attempt status. */

export function normalizeAttemptPaperId(id) {
  return String(id || '').replace(/\s+/g, '').toUpperCase();
}

/** The paper id of every topic paper in the sections (rows are topic papers). */
export function collectTopicPaperIds(topicSections = []) {
  const ids = [];
  (topicSections || []).forEach((sec) => {
    (sec.tiers || []).forEach((tier) => {
      (tier.params || []).forEach((param) => {
        if (param?.paper_id) ids.push(param.paper_id);
      });
    });
  });
  return ids;
}

/** Stable key so workspace status fetches are not cancelled on every parent rerender. */
export function topicAttemptStatusRequestKey(ids = []) {
  return [...new Set((ids || []).filter(Boolean).map((id) => String(id)))].sort().join('\n');
}

export function topicAttemptRowFromMap(dbPapers, paperId) {
  const papers = dbPapers || {};
  if (!paperId) return null;
  if (papers[paperId]) return papers[paperId];
  const want = normalizeAttemptPaperId(paperId);
  const hit = Object.keys(papers).find((key) => normalizeAttemptPaperId(key) === want);
  return hit ? papers[hit] : null;
}

function normalizeAttemptStatus(status) {
  return String(status || '').trim().toLowerCase().replace(/-/g, '_');
}

export function topicRowAction(dbRow, locallyDone = false) {
  const dbStatus = normalizeAttemptStatus(dbRow?.status);
  if (dbStatus === 'in_progress' || dbStatus === 'progress') {
    return { status: 'progress', label: 'Resume', forceNew: false, resume: true };
  }
  if (dbStatus === 'completed' || dbStatus === 'complete' || dbStatus === 'done' || locallyDone) {
    return { status: 'done', label: 'Retake', forceNew: true, resume: false };
  }
  return { status: 'none', label: 'Start', forceNew: false, resume: false };
}

/** End Exam mid-paper pauses. A drill with every question answered completes,
 * as does finishing the last review (Retake). */
export function shouldPauseTopicDrillOnEndExam({
  topicDrill, isSubmitted, phase, allAnswered,
} = {}) {
  if (!topicDrill || isSubmitted || allAnswered === true) return false;
  const p = String(phase || '');
  if (p === 'post_exam' || /_review$/.test(p)) return false;
  return true;
}

export function topicDrillResumeSnapshot(saved, { examName, lnatSection } = {}) {
  const exam = String(examName || '').toUpperCase();
  const lnatB = exam === 'LNAT' && (lnatSection === 'B' || lnatSection === 'section_b');
  const fallbackPhase = (exam === 'UCAT' || exam === 'TARA' || exam === 'ESAT')
    ? 'm0_items'
    : (lnatB ? 'p2_items' : 'p1_items');
  const index = Number(saved?.resume_question_index);
  return {
    phase: saved?.resume_phase || fallbackPhase,
    questionIndex: Number.isFinite(index) ? index : 0,
    reviewMode: false,
  };
}
